import { HasId } from '../../../../shared/basic-data-management/has-id.interface';

export class AntenneTLR implements HasId {
	id!: number;
	code!: string;
	couleur!: string;
	description!: string;
	nom!: string;
	agenceId!: number;
	telephoneAstreintes!: string[];

	constructor() {
	}
}